var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":!_vm.logs || _vm.logs.length == 0,"small":"","color":_vm.getColor},on:{"click":function($event){return _vm.ignore()}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(_vm._s(_vm.getIcon))]),_vm._v("\n  "+_vm._s(_vm.stateText)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }